import { KeyValuePipe } from '@angular/common'
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  linkedSignal,
  output,
} from '@angular/core'
import { FormField, form } from '@angular/forms/signals'

import { omit as _omit } from 'lodash'

import { FlxButtonModule, FlxFormControlModule, FlxModalModule } from '@flowx/angular-ui-toolkit'

import { ThemeColorShades } from '../../color.helpers'
import { FlxHexColorMaskDirective } from '../../hex-color-mask.directive'

/** Edits every shade of one colour; changes are a local draft until Save. */
@Component({
  selector: 'flx-colors-shades-editor',
  imports: [
    KeyValuePipe,
    FormField,
    FlxHexColorMaskDirective,
    FlxModalModule,
    FlxButtonModule,
    FlxFormControlModule,
  ],
  templateUrl: './colors-shades-editor.component.html',
  styleUrls: ['./colors-shades-editor.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'max-h-full' },
})
export class FlxColorsShadesEditorComponent {
  readonly #draft = linkedSignal<ThemeColorShades>(() => ({ ...this.shades() }))

  readonly shades = input.required<ThemeColorShades>()
  readonly colorName = input<string>()
  readonly closeModal = output<void>()
  readonly saveShades = output<Partial<ThemeColorShades>>()

  readonly shadesForm = form(this.#draft)
  /** Shades 0 and 1000 are fixed (transparent and black) and not editable. */
  readonly displayShades = computed(() => _omit({ ...this.shades() }, ['0', '1000']))

  save(): void {
    this.saveShades.emit(this.#draft())
    this.closeModal.emit()
  }
}
